<button
  class="flex gap-[8px] justify-center items-center text-G900 font-medium"
>
  <img src="/assets/massimo/svg/fi_edit.svg" alt="edit" />
  Back to Editing
</button>
